<div #layerLabelsArea class="layer-labels" *ngIf="layerColumns && layerId && labelClass">
    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Column: </label>
        <select class="pull-right" [(ngModel)]="selectedLayerColumn">
            <option *ngFor="let column of layerColumns" [ngValue]="column">
                {{ column.alias }}
            </option>
        </select>
    </div>
    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Start Showing At Map Level: </label>
        <select class="pull-right" [(ngModel)]="labelClass.minScale">
            <option *ngFor="let level of startScaleIntervals" [title]="level.value" [disabled]="level.value!==0 && level.value < labelClass.maxScale" [ngValue]="level.value">
                {{ level.label }}
            </option>
        </select>
    </div>
    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Stop Showing At Map Level: </label>
        <select class="pull-right" [(ngModel)]="labelClass.maxScale">
            <option *ngFor="let level of stopScaleIntervals" [title]="level.value" [disabled]="labelClass.minScale!==0 && level.value > labelClass.minScale" [ngValue]="level.value">
                {{ level.label }}
            </option>
        </select>
    </div>
    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Label Placement: </label>
        <select class="pull-right" [(ngModel)]="labelClass.labelPlacement">
            <option *ngFor="let placement of placements" [ngValue]="placement.value">
                {{ placement.name }}
            </option>
        </select>
    </div>
    <div *ngIf="layerSymbol">
        <mc-text-symbol-editor-ng id="textEditor" #textSymbolEditor [layerSymbol]="layerSymbol" [showTextInput]="false">
        </mc-text-symbol-editor-ng>
    </div>
    <div class="clearfix legendWideControlGroup">
        <label class="pull-left">Halo: </label>
        <input class="pull-right" type="checkbox" [checked]="includeHalo" (change)="includeHalo = !includeHalo">
    </div>
    <div [hidden]="!includeHalo">
        <div class="clearfix legendWideControlGroup">
            <label class="pull-left" (click)="colorPicker.showColorPicker = !colorPicker.showColorPicker">Halo Color:</label>
            <mc-color-picker-ng #colorPicker
                                class="color-swatch right"
                                [color]="haloOptions.color"
                                (colorChange)="updateColorFromPicker($event)">
            </mc-color-picker-ng>
        </div>
        <div class="clearfix legendWideControlGroup">
            <label class="pull-left">Halo Size: </label>
            <input class="pull-right" type="number" [(ngModel)]="haloOptions.size" min="0" max="24">
        </div>
    </div>
    <div *ngIf="showLoading">
        <div class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
            <div class="loader-text"> Executing...</div>
        </div>
    </div>
    <div class="button-container">
        <button class="btn apply" (click)="apply()">Apply Labels to Layer</button>
        <button class="btn btn-clear cancel" (click)="remove()">Remove</button>
    </div>
</div>
